import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGLoadingPath from './Loading.styled';

export default class PathBlock extends Component {
    constructor(props) {
        super(props);
        this.pathRef = React.createRef();
        this.state = {
            pathLength: 0,
        };
    }

    componentDidMount() {
        this.setState({ pathLength: this.pathRef.current.getTotalLength() });
    }

    render() {
        const { pathLength } = this.state;
        const { loading } = this.props;
        return (
            <SVGLoadingPath loading={loading} pathLength={pathLength} viewBox="0 0 800.22 323"><path ref={this.pathRef} d="M408.33,173.53Q430,152.35,451.7,131.16c27.17-26.5,55.83-51.19,87.71-72C570.35,39,603.72,24.75,640.94,24c44.68-.85,83.14,15.19,114.37,47.93,47.26,49.53,54.7,126.29,17.76,184.39-37.21,58.52-111.8,86.05-180.55,61.4-37.13-13.32-68.52-35-98.37-59.55-30.37-25-58-52.93-85.82-80.73h0c-27.77-27.81-59.4-59.68-89.76-84.68-29.85-24.56-61.24-46.23-98.37-59.55C151.45,8.6,76.86,36.13,39.65,94.65,2.71,152.75,10.15,229.51,57.41,279,88.64,311.78,127.1,327.83,171.78,327c37.22-.7,70.59-15,101.53-35.15,31.88-20.78,60.53-45.47,87.71-72q21.71-21.18,43.37-42.38" transform="translate(-6.25 -14.01)" /></SVGLoadingPath>
        );
    }
}

PathBlock.propTypes = {
    loading: PropTypes.bool.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/atoms/Loading/Loading.js